import { Link, useLocation } from 'react-router-dom';

function AdminBottomNav() {
  const location = useLocation();

  const navItems = [
    { path: '/admin', icon: 'chart-bar', label: 'Dashboard' },
    { path: '/admin/produtos', icon: 'box', label: 'Produtos' },
    { path: '/admin/pedidos', icon: 'shopping-cart', label: 'Pedidos' },
    { path: '/admin/categorias', icon: 'tags', label: 'Categorias' },
    { path: '/admin/promocoes', icon: 'percent', label: 'Promoções' },
  ];

  const isActive = (path: string) => {
    if (path === '/admin') {
      return location.pathname === '/admin' || location.pathname === '/admin/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="bottom-nav">
      {navItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
        >
          <i className={`fas fa-${item.icon}`}></i>
          <span>{item.label}</span>
        </Link>
      ))}
    </nav>
  );
}

export default AdminBottomNav;

